(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.isScrolled = false;
      this.isMenuHovered = false;
      this.mouseoutTimeout = null;
      this.elementsReady = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || 
                                   this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // Read homepage status from data attribute
      this.isHomepage = this.getAttribute('data-is-homepage') === 'true';

      // Wait for elements to be ready
      requestAnimationFrame(() => {
        this.cacheElements();
        this.initializeHeaderState();
        this.setupMenuListeners();
        this.elementsReady = true;
      });

      this.setHeaderHeight();
      
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    cacheElements() {
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerElement = this.headerWrapper?.querySelector('.header');
      this.overlay = document.getElementById('overlay');
      this.menuItems = Array.from(document.querySelectorAll('.header__inline-menu li'));
      this.megaMenuContents = Array.from(document.querySelectorAll('.mega-menu__content'));
      this.menuLinks = Array.from(document.querySelectorAll('.header__menu-item'));
      this.cartBubble = document.querySelector('.cart-count-bubble');
      this.searchModal = this.querySelector('details-modal');
      
      
      // Cache all icon paths
      const iconWrappers = document.querySelectorAll('.change-icon-color');
      this.iconPaths = [];
      iconWrappers.forEach(wrapper => {
        const paths = wrapper.querySelectorAll('path');
        this.iconPaths.push(...Array.from(paths));
      });
      
    }

    initializeHeaderState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isScrolled = scrollTop > 50;
      
      
      if (this.isHomepage) {
        if (!this.isScrolled) {
          this.applyHomepageTopStyle();
        } else {
          this.applyScrolledStyle();
        }
      } else {
        if (!this.isScrolled) {
          this.applyOtherPagesTopStyle();
        } else {
          this.applyScrolledStyle();
        }
      }
    }

    setupMenuListeners() {
      this.menuItems.forEach((item) => {
        item.addEventListener('mouseover', () => this.handleMenuHover(true));
        item.addEventListener('mouseout', (e) => this.handleMenuHoverOut(e, item));
      });

      this.megaMenuContents.forEach((megaMenu) => {
        megaMenu.addEventListener('mouseover', () => this.handleMenuHover(true));
        megaMenu.addEventListener('mouseout', (e) => this.handleMegaMenuOut(e, megaMenu));
      });
    }

    handleMenuHover(isHovered) {
      if (this.mouseoutTimeout) {
        clearTimeout(this.mouseoutTimeout);
        this.mouseoutTimeout = null;
      }

      this.isMenuHovered = isHovered;
      
      if (isHovered) {
        this.applyMenuHoverStyle();
      }
    }

    handleMenuHoverOut(e, item) {
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && item.contains(relatedTarget)) {
        return;
      }

      this.mouseoutTimeout = setTimeout(() => {
        this.isMenuHovered = false;
        this.updateHeaderStyle();
      }, 200);
    }

    handleMegaMenuOut(e, megaMenu) {
      const relatedTarget = e.relatedTarget;
      const parentLi = megaMenu.closest('li');
      
      if (relatedTarget && (
        (parentLi && parentLi.contains(relatedTarget)) || 
        (this.headerWrapper && this.headerWrapper.contains(relatedTarget))
      )) {
        return;
      }

      this.mouseoutTimeout = setTimeout(() => {
        this.isMenuHovered = false;
        this.updateHeaderStyle();
      }, 200);
    }

    updateHeaderStyle() {
      if (this.isMenuHovered) {
        this.applyMenuHoverStyle();
      } else if (this.isHomepage) {
        if (this.isScrolled) {
          this.applyScrolledStyle();
        } else {
          this.applyHomepageTopStyle();
        }
      } else {
        if (this.isScrolled) {
          this.applyScrolledStyle();
        } else {
          this.applyOtherPagesTopStyle();
        }
      }
    }

    applyHomepageTopStyle() {
      if (this.headerWrapper) {
        this.headerWrapper.style.removeProperty('background');
        this.headerWrapper.classList.remove('scrolled');
        // Keep top at 29px when at top of homepage
        this.headerWrapper.style.top = '29px';
      }
      if (this.headerElement) {
        this.headerElement.style.removeProperty('background');
      }
      if (this.overlay) {
        this.overlay.style.display = 'none';
      }
      
      this.setTextColor('#002F6C');
      this.setIconColor('#002F6C');
      this.setCartBubbleColor('#000', '#fff');
    }

    applyOtherPagesTopStyle() {
      if (this.headerWrapper) {
        this.headerWrapper.style.setProperty('background', '#fff', 'important');
        this.headerWrapper.classList.remove('scrolled');
        // Keep top at 29px when at top of other pages
        this.headerWrapper.style.top = '29px';
      }
      if (this.headerElement) {
        this.headerElement.style.setProperty('background', '#fff', 'important');
      }
      if (this.overlay) {
        this.overlay.style.display = 'none';
      }
      
      this.setTextColor('#002F6C');
      this.setIconColor('#002F6C');
      this.setCartBubbleColor('#000', '#fff');
    }

    applyScrolledStyle() {
      if (this.headerWrapper) {
        this.headerWrapper.style.removeProperty('background');
        this.headerWrapper.classList.add('scrolled');
        // Move to top when scrolled
        this.headerWrapper.style.top = '0px';
      }
      if (this.headerElement) {
        this.headerElement.style.removeProperty('background');
      }
      if (this.overlay) {
        this.overlay.style.display = 'block';
      }
      
      this.setTextColor('white');
      this.setIconColor('#fff');
      this.setCartBubbleColor('#fff', '#002f6c');
    }

    applyMenuHoverStyle() {
      if (this.headerWrapper) {
        this.headerWrapper.style.setProperty('background', '#fff', 'important');
        this.headerWrapper.classList.remove('scrolled');
        // If scrolled, keep at top:0, otherwise top:29px
        if (this.isScrolled) {
          this.headerWrapper.style.top = '0px';
        } else {
          this.headerWrapper.style.top = '29px';
        }
      }
      if (this.headerElement) {
        this.headerElement.style.setProperty('background', '#fff', 'important');
      }
      if (this.overlay) {
        this.overlay.style.display = 'none';
      }
      
      this.setTextColor('#002F6C');
      this.setIconColor('#002F6C');
      this.setCartBubbleColor('#000', '#fff');
    }

    setTextColor(color) {
      this.menuLinks.forEach((link) => {
        if (color === '#002F6C') {
          link.classList.add('list_color');
          link.classList.remove('list_color_white');
        } else {
          link.classList.remove('list_color');
          link.classList.add('list_color_white');
        }
      });
    }

    setIconColor(color) {
      this.iconPaths.forEach(path => {
        path.setAttribute('stroke', color);
      });
    }

    setCartBubbleColor(bg, text) {
      if (this.cartBubble) {
        this.cartBubble.style.background = bg;
        this.cartBubble.style.color = text;
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mouseoutTimeout) {
        clearTimeout(this.mouseoutTimeout);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const wasScrolled = this.isScrolled;
      this.isScrolled = scrollTop > 50;

      // Update style only if elements are ready and not hovering menu
      if (this.elementsReady && !this.isMenuHovered && wasScrolled !== this.isScrolled) {
        this.updateHeaderStyle();
      }

      // Don't hide header when search modal is open (especially when results are showing)
      if (this.searchModal?.isOpen?.()) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Sticky header show/hide logic
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    const plusIcon = summary.querySelector('.add-new-product');
    const minusIcon = summary.querySelector('.add-new-minus-product');

    if (!content || !summary) return;

    // 👉 helper to update UI
    const updateState = (el, isOpen) => {
      const sum = el.querySelector('summary');
      const plus = sum.querySelector('.add-new-product');
      const minus = sum.querySelector('.add-new-minus-product');

      sum.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (plus && minus) {
        plus.style.display = isOpen ? 'none' : 'inline-block';
        minus.style.display = isOpen ? 'inline-block' : 'none';
      }
    };

    // initial state
    updateState(details, details.open);

    if (details.open) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = details.open;

      if (isOpen) {
        // CLOSE
        content.style.maxHeight = content.scrollHeight + 'px';

        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });

        content.addEventListener(
          'transitionend',
          () => {
            details.removeAttribute('open');
            updateState(details, false); // 👈 FIX
          },
          { once: true }
        );
      } else {
        // OPEN
        details.setAttribute('open', true);
        updateState(details, true); // 👈 FIX

        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
        });
      }

      // close others
      accordions.forEach((other) => {
        if (other !== details && other.open) {
          const otherContent = other.querySelector('.accordion__content');

          otherContent.style.maxHeight = otherContent.scrollHeight + 'px';

          requestAnimationFrame(() => {
            otherContent.style.maxHeight = '0px';
          });

          otherContent.addEventListener(
            'transitionend',
            () => {
              other.removeAttribute('open');
              updateState(other, false); // 👈 FIX
            },
            { once: true }
          );
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
